import React from "react";
import { ComingSoon } from "../ComingSoon";
import PaperCard from "../PaperCard";
import "./Home.css";

export const PostersDemosForum = () => {
  const posters = [
    {
      paperID: 1571128555,
      title:
        "Beyond Training: A Personalized Holistic Injury Prediction in Triathletes",
      authors: "Bruno Rodrigues; Leonardo Rossi",
    },
    {
      paperID: 1571129327,
      title:
        "Managing Real-time Mobile Applications in Reconfigurable Industrial Cloud-to-Things Systems",
      authors: "Marco Pettorali",
    },
    {
      paperID: 1571129856,
      title: "A Roundabout Video Dataset for Vehicle Trajectory Prediction",
      authors:
        "Yi Han; Ruichun Zhou; Xiaotong Zhou; Jiantong Weng; Yang Yi; Zhenghao Su; Zhenhui Yuan",
    },
    {
      paperID: 1571135138,
      title:
        "UAV-aided Optimal Physical Layer Security in Integrated Satellite and Terrestrial Networks",
      authors:
        "Tinh Thanh Bui; Vishal Sharma; Antonino Masaracchia; Trung Q. Duong",
    },
    {
      paperID: 1571137969,
      title: "Enhancing Reliability of Smart Systems Using In-Memory Computing",
      authors: "Mojtaba Mahdavi",
    },
    {
      paperID: 1571138351,
      title:
        "Does One Noise Fit All? Analyzing Utility in Transportation Mode-Based Anonymization",
      authors: "Debasree Das; Rahat Rafiq; Daniela Nicklas",
    },
    {
      paperID: 1571138828,
      title: "WiP: Context-Aware Recommendations for Smart Campus Environments",
      authors:
        "Vincenzo Agate; Alessandra De Paola; Giuseppe Lo Re; Marco Morana; Antonio Virga",
    },
    {
      paperID: 1571139418,
      title:
        "Resilient NFV Service Chains under Energy-Aware Attacks: A Bilevel Optimization Approach",
      authors:
        "Mohammad Ali Raayatpanah; Jocelyne Elias; Fabio Martignon; Andrea Pimpinella; Michael Poss",
    },
    {
      paperID: 1571139592,
      title:
        "Semi-Automatic 3D medical image segmentation using UNet with Five-Point extreme guidance",
      authors:
        "Giada Anastasi; Michela Franchini; Stefania Pieroni; Sabrina Molinaro",
    },
    {
      paperID: 1571141393,
      title:
        "Smart Beamforming: Leveraging In-Memory Computing for Intelligent Wireless Systems",
      authors: "Mojtaba Mahdavi",
    },
    {
      paperID: 1571142683,
      title:
        "Power Saving in Open RAN by Using Advanced CPU Scheduling Algorithm",
      authors: "Saish Pramod Urumkar; Sachin Sharma",
    },
  ];

  const demos = [
    {
      paperID: 1571138652,
      title:
        "Demonstrating the Impact of CPU Scheduling on Power Consumption in Virtualized Open RAN",
      authors: "Saish Pramod Urumkar; Sachin Sharma",
    },
    {
      paperID: 1571139358,
      title:
        "EaseTalk: An LLM-Driven Speech Practice Tool for Real-Life Scenarios",
      authors:
        "Malik Muhammad Qirtas; Marco Faggiani; Pauline Frizelle; Fiona Ryan; Nicole Muller; Andrea Visentin",
    },
    {
      paperID: 1571139393,
      title:
        "DEMO: A multi-modal approach for monitoring COPD patients - the TOLIFE project",
      authors:
        "Francesco Di Rienzo; Alberto Greco; Alessandro Tognetti; Carlo Vallati; Eleonora Melissa; Pasquale Bufano; Nicola Carbonaro; Francesco Bossi; Marco Laurino; Michele Zanoletti; Gianluca Rho; Carlotta Marinai; Lucia Arcarisi; Victor Segura Ruiz; Manuel Torres Brabo; Patricia Abril-JImenez",
    },
    {
      paperID: 1571145690,
      title:
        "Web-CozyBench: A Web-Based Platform for Benchmarking Thermal Comfort Provision Using Digital Twins",
      authors:
        "Jun Ma; Aziz Boubaker; Sabrine Azaiez; Roberto Yus; Georgios Bouloukakis",
    },
    {
      paperID: 1571145694,
      title:
        "Beyond Doppler: Demonstrating Phase-Based Ego-Speed Estimation on Embedded mmWave Radar",
      authors:
        "Argha Sen; Soham Chakraborty; Soham Tripathy; Sandip Chakraborty",
    },
  ];

  const forum = [
    {
      paperID: 1571140552,
      title:
        "Towards Trust-Aware Routing of Ground Vehicle Drivers to Mitigate Travel Time",
      authors:
        "Doris E M Brown (Missouri University of Science and Technology, USA)",
    },
    {
      paperID: 1571142031,
      title: "Supervised Contrastive Learning for Coastal Resilience",
      authors: "Kathy Bannigan (Atlantic Technological University, Ireland)",
    },
    {
      paperID: 1571142107,
      title:
        "Exploring Urban Air Mobility Applications by Optimizing Operations through Computational Means",
      authors:
        "Debjyoti Sengupta (Missouri University of Science and Technology, USA)",
    },
    {
      paperID: 1571142244,
      title:
        "Domain Adaptation Approach for WiFi-based Human Activity Recognition",
      authors: "Amany Elkelany (Technological University Dublin, Ireland)",
    },
    {
      paperID: 1571142403,
      title:
        "Securing Federated Learning against Targeted Attackers using Weight Similarity",
      authors:
        "Priyesh Ranjan (Missouri University of Science and Technology, USA)",
    },
  ];

  return (
    <div className="form-page-layout">
      <div className="form-layout">
        <h2 className="title">Posters</h2>
        <h4>
          15:30-17:00, 17th June in Atrium, Ground Floor, Western Gateway
          Building, UCC
        </h4>
        {posters.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h2 className="title">Demos</h2>
        <h4>
          15:30-17:00, 17th June in Atrium, Ground Floor, Western Gateway
          Building, UCC
        </h4>
        {demos.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h2 className="title">PhD Forum</h2>
        <h4>
          9:00-11:30, 16th June in Room T102, Tourism Building, Munster
          Technological University
        </h4>
        <p>
          The PhD forum is a mentoring session which is a closed-door event with
          mentors and PhD candidates. This year, we have 5 PhD candidates. Each
          candidate will prepare a 2-minute lightning slide and a 7-minute
          presentation on their PhD plan. They will also present a poster of
          their PhD forum during the poster session with everyone else.
        </p>
        {forum.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
      </div>
    </div>
  );
};
